import React from 'react'
import loadingImg from '../assets/images/loadingImg.png'
import './commanComponents.css'

export default function Loader() {
  return (
    <div className='loader'>
      <div className='loader-spinner-container'>
        <div className='loader-spinner-ring'></div>
        <div className='loader-logo-card'>
          <img src={loadingImg} alt={'Loading...'} className='loader-logo-img' />
        </div>
      </div>
    </div>
  )
}
